import axios from '../../common/axios.js'
import Input from '../../common/forms/Input.vue'

export default {
	data(){
		return {
			email: '',
			error: false,
			error_sso: false,
			success: false
		}
	},
	methods:{
		recuppass(){
			var self = this;
			self.error = false;
			axios.post('/plugin_projet/plugin_projet_iannuaire/recuppass', {
				data:{
					Profil: {
						email: self.email
					}
				}
			})
			.then(function (response) {
				if(response.data == 'KO'){
					self.error = true;
					self.error_sso = false;
					self.success = false;
				}else if(response.data == 'KO:SSO'){
					self.error = false;
					self.error_sso = true;
					self.success = false;
				}else{
					self.error = false;
					self.error_sso = false;
					self.success = true;
				}
			}).catch(function (error) {})
		}
	},
	components: {
		Input
	}
}
